const reviews = [
  {
    id: 1,
    image: '/images/reviews-gallery/review-garage.jpg',
    quote: "Excellent work. Bear Electric did a complete electrical renovation on my home. They're easy to reach, professional, always on time and do quality job. If you're looking for a great electrician, look no further! Thanks, Bear Electric crew!",
    name: "Jami Johnson"
  },
  {
    id: 2,
    image: '/images/reviews-gallery/review-kitchen.jpg',
    quote: "I really appreciate the electricians at Bear Electric for showing up on time and giving honest advice on what could and should/shouldn’t be done.I had indoor and outdoor lighting, fans and cameras installed. They were very professional and worked hard. I will definitely use them for all of my electrical needs.",
    name: "Barbara Ledford"
  },
  {
    id: 3,
    image: '/images/reviews-gallery/review-decking.jpg',
    quote: "Excellent and efficient work installing light fixtures, ceiling fans, outlets and security cameras! Team went above and beyond ordering custom parts and ensuring everything was connected and working properly on a tight deadline! 10/10 would call Bear Electric again!",
    name: "K L"
  },
  {
    id: 4,
    image: '/images/reviews-gallery/review-consumer-unit.jpg',
    quote: "Bear Electric Team did an amazing job replacing all outlets and updating all the old wiring and breakers. They're top notch professionals and I’d highly recommended for all things electric.",
    name: "Matthew DeOliveira"
  },
];

export default reviews;